import React, { Component } from 'react'
import { compose, graphql } from 'react-apollo'
import Radium, { keyframes } from 'radium'
import {
  SET_AGENT_SIZE,
  SET_AGENT_POSITION,
  GET_AGENT_STATE
} from '../../apollo/actions'
import { Constants } from '@sukiai/components'
import downwardArrow from '../../lib/assets/icons/down-arrow.svg'
import {
  INTRO_TUTORIAL_SCREEN_TOP_TEXT,
  INTRO_TUTORIAL_SCREEN_BOTTOM_TEXT,
  ALT_TEXT
}
  from './constants'

const { AGENT } = Constants

const opacityAnimation = keyframes({
  '0%': { opacity: 0 },
  '50%': { opacity: 0.5 },
  '100%': { opacity: 1 }
},
'opacityAnimation'
)

const styles = {
  contentContainer: {
    width: '50%',
    height: '100%',
    left: '25%',
    position: 'fixed'
  },
  topText: {
    fontSize: '2.5em',
    color: '#2D5E60',
    animationName: opacityAnimation,
    animationDuration: '1s',
    animationTimingFunction: 'fade-in',
    animationDelay: '0',
    animationIterationCount: 1,
    overflow: 'hidden',
    display: 'inline-block',
    position: 'fixed',
    top: '10%',
    textAlign: 'center',
    width: '50%'
  },
  bottomCenterText: {
    marginLeft: '25%',
    marginTop: '46%',
    fontSize: '2.5em',
    color: '#2D5E60',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    opacity: 0,
    animationName: opacityAnimation,
    animationDuration: '0.5s',
    animationTimingFunction: 'fade-in',
    animationDelay: '2s',
    animationIterationCount: 1,
    animationFillMode: 'forwards',
    display: 'inline-block',
    position: 'fixed',
    width: '50%',
    bottom: '15%',
    left: '0',
    textAlign: 'center'
  },
  downwardArrow: {
    height: '11%',
    opacity: 0,
    animationName: opacityAnimation,
    animationDuration: '1s',
    animationTimingFunction: 'fade-in',
    animationDelay: '1s',
    animationIterationCount: 1,
    animationFillMode: 'forwards',
    position: 'fixed',
    top: '18%',
    left: '49%'
  }
}

// Intro tutorial screen where agent wake related info comes up
class IntroTutorialWakeScreen extends Component {
  componentWillReceiveProps (nextProps) {
    const { setAgentSize } = nextProps
    if (this.props.agentState !== nextProps.agentState && nextProps.agentState === AGENT.STATE.READY) {
      setAgentSize(AGENT.SIZE.LARGE)
      setTimeout(nextProps.parentCallback, 1000)
    }
  }

  componentWillMount () {
    const {
      setAgentSize,
      setAgentPosition
    } = this.props

    setAgentSize(AGENT.SIZE.THREE_QUARTERS)
    setAgentPosition(AGENT.POSITION.CENTER)
  }

  render () {
    return (
      <div style={styles.contentContainer}>
        <div data-cy='oobe-wake-screen-title' style={styles.topText}>{INTRO_TUTORIAL_SCREEN_TOP_TEXT}</div>
        <img data-cy='oobe-wake-downward-arrow' style={styles.downwardArrow} src={downwardArrow} alt={ALT_TEXT} />
        <div data-cy='oobe-wake-secondary-text' style={styles.bottomCenterText}>{INTRO_TUTORIAL_SCREEN_BOTTOM_TEXT}</div>
      </div>
    )
  }
}

export default compose(
  graphql(SET_AGENT_SIZE, {
    props: ({ mutate }) => ({
      setAgentSize: agentSize => mutate({
        variables: { agentSize }
      })
    })
  }),
  graphql(SET_AGENT_POSITION, {
    props: ({ mutate }) => ({
      setAgentPosition: agentPosition => mutate({
        variables: { agentPosition }
      })
    })
  }),
  graphql(GET_AGENT_STATE, {
    props: ({ data: { agentState } }) => ({
      agentState
    })
  })
)(Radium(IntroTutorialWakeScreen))
